import React from "react";
import { Spinner } from "react-bootstrap";

const Loader = () => {
  return (
    <>
      <style>{`
        .global-loader-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.5); /* Dark transparent background */
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 9999; /* Ensure it is above other elements */
        }
      `}</style>
      <div className="global-loader-overlay">
        
      
          <div style={{background: "rgba(0, 0, 0, 0.5)"}} className="sk-three-bounce">
            <div  className="sk-child sk-bounce1"></div>
            <div className="sk-child sk-bounce2"></div>
            <div  className="sk-child sk-bounce3"></div>
          </div>
        </div>
    </>
  );
};

export default Loader;
